var React = require('react');

function HamburgerMenuClose (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.15625","y":"0.958984","width":"25.9997","height":"2.39996","rx":"1.19998","transform":"rotate(45 2.15625 0.958984)","fill":"#F8672A","key":0}),React.createElement("rect",{"x":"18.4359","y":"4.76074","width":"20.0461","height":"2.39996","rx":"1.19998","transform":"rotate(135 18.4359 4.76074)","fill":"#30E4BE","key":1})]);
}

HamburgerMenuClose.defaultProps = {"width":"21","height":"22","viewBox":"0 0 21 22","fill":"none"};

module.exports = HamburgerMenuClose;

HamburgerMenuClose.default = HamburgerMenuClose;
